export default "__VITE_ASSET__b27557f7__"